module.exports = __webpack_public_path__ + "static/media/imagen2.76061a61.jpg";